import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-product-item-list',
  templateUrl: './product-item-list.component.html',
  styleUrls: ['./product-item-list.component.scss']
})
export class ProductItemListComponent implements OnInit {
  productsList: any;
  constructor(
    public TCDialogue: MatDialog,
    private modalRef: MatDialogRef<ProductItemListComponent>,
    private csObj: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    console.log(this.data.userType.id._id)
    this.getRestaurantProducts(this.data.userType.id._id);
  }

  onClickPP() {
    this.modalRef.close();
  }

  // ********************************************************************************************t
  // getRestaurantProducts start
  getRestaurantProducts(id: any) {
    let data = {
      page: 1,
      pageLimit: 1000,
      restaurantId: id,
    }

    this.csObj.getRestauratProducts(data).subscribe((res: any) => {
      if (res.status == 200) {
        this.productsList = res.output.productData.list;


      }
    })
  }

  convertToDecimal(data:any){
    return data?.toFixed(2);
  }
  // sgetRestaurantProducts END
  // ********************************************************************************************

}
